import type { HeroData } from './types';

// Game-specific mapping: other games retain their explicitly configured theme.
export const arcanatacticsThemes: Record<string, string> = {
  火焰: 'flame', 寒气: 'frost', 自然: 'nature',
  光辉: 'light', 黑暗: 'dark', 钢铁: 'steel',
};

export function coverTheme(hero: Pick<HeroData, 'gameId' | 'traits' | 'theme'>) {
  const attribute = hero.traits.find(trait => trait.label === '属性')?.name;
  return (hero.gameId === 'arcanatactics' && attribute && arcanatacticsThemes[attribute]) || hero.theme;
}
